import React, { useState, useContext, useEffect } from "react"
import { Row } from "reactstrap"
import { Box, LinearProgress } from "@mui/material"
import Loading from "common/Loading"
import ModalFirstPage from "./modalFirstPage"
import * as amplitude from "@amplitude/analytics-browser"
import ModalCallError from "common/modalCallError"
import { useNavigate } from "react-router-dom"
import AuthContext from "../../context/auth/authContext"
import ProjectContext from "context/projects/projectContext"
import ContactContext from "../../context/contact/contactContext"
import PersonalModal from "./PersonalModal"
import UploadModal from "./UploadModal"
import WaitingModal from "./WaitingModal"
import SuccessModal from "./SuccessModal"
import CardProject from "./CardProject"
import NoProjects from "components/Dashboard/NoProjects"
import ModalFirstProject from "./ModalFirstProject"
import MobileModalNew from "./mobileModalAtt"
import i18n from "i18n"
import ModalSelectTypeProject from "./ModalSelectTypeProject"
import ModalWaitingPendingActions from "./ModalWaitingPendingActions"
import { HelveticaInput } from "common/inputs"
import useDashboardComponent from "hooks/dashboard/useDashboardComponent"
import DashboardComponentIconMenu from "./DashboardComponentIconMenu"

const DashboardComponent = () => {
  const [modal_standard, setModal_standard] = useState(false)
  const [modal_upload, setModal_upload] = useState(false)
  const [waitModal, setWaitModal] = useState(false)
  const [successModal, setSuccessModal] = useState(false)
  const onClickPersonalModal = () => setModal_standard(!modal_standard)
  const authContext = useContext(AuthContext)
  const projectContext = useContext(ProjectContext)
  const contactContext = useContext(ContactContext)

  const {
    projects,
    getProjects,
    loadingProjects,
    deleteProject,
    loadingImportPlantilla,
  } = projectContext
  const { Contacts, getContacts } = contactContext
  const { user, pendingActions, loadingPendingActions } = authContext

  const { view, dashboardConfigFilters, setViewMode } = useDashboardComponent()

  const [uploadDB, setUploadDB] = useState(false)
  const [projectSeleccionado, setSeleccionado] = useState(null)

  const [modal_first, setModal_first] = useState(false)
  const navigate = useNavigate()
  const [esPrimerProyecto, setFirstProject] = useState(false)
  const [initialProjectsFetchDone, setInitialProjectsFetchDone] =
    useState(false)

  useEffect(() => {
    initAmplitude()
    getContacts()
  }, [])

  const initAmplitude = async () => {
    amplitude.track("Dashboard Visited")
  }

  useEffect(() => {
    let cancelled = false
    getProjects().finally(() => {
      if (!cancelled) setInitialProjectsFetchDone(true)
    })
    return () => {
      cancelled = true
    }
  }, [getProjects])

  const showBlockingProjectsLoading =
    loadingImportPlantilla ||
    (projects.length === 0 && (loadingProjects || !initialProjectsFetchDone))

  const [openSelectFirstPage, setOpenSelectFirstPage] = useState(false)
  const [openError, setOpenError] = useState(false)
  const [errorToSend, setErrorToSend] = useState("")

  useEffect(() => {
    if (!user) return
    if (user["custom:firstPageSelected"]) return

    setOpenSelectFirstPage(true)
  }, [user, pendingActions])

  const [openModalPendingActions, setOpenModalPendingActions] = useState(false)

  useEffect(() => {
    if (!loadingPendingActions) return
    setOpenModalPendingActions(true)
  }, [loadingPendingActions])

  useEffect(() => {
    if (!user) return

    if (window.smartlook) {
      window.smartlook("identify", user.sub, {
        name: user["custom:nombre_apellido"],
        email: user.email,
        phone: user["custom:mobile"],
        subscription_plan: user["custom:subscription_plan"],
        subscription_status: user["custom:subscription_status"],
      })
      window.smartlook("record", { forms: true })
      window.smartlook("record", { numbers: true })
    }

    if (!window.heap) return
    window.heap.identify(user.sub)
    window.heap.addUserProperties({ email: user.email })
  }, [])

  const [mobileModal, setMobileModal] = useState(false)
  const handleOpenNew = () => {
    setModalNew(true)
  }
  const [modalNew, setModalNew] = useState(false)
  useEffect(() => {
    if (window.innerWidth >= 750) return
    setMobileModal(true)
  }, [window.innerWidth])

  const [palabrasFiltered, setPalabrasFiltered] = useState("")

  return (
    <>
      <div
        id="centerButton"
        style={{
          justifyContent: "right",
          marginTop: "0px",
          marginBottom: "32px",
        }}
      >
        {view === 0 && (
          <HelveticaInput
            value={palabrasFiltered}
            onChange={e => setPalabrasFiltered(e.target.value)}
            style={{
              width: "300px",
              height: "40px",
              marginRight: "20px",
              marginTop: "1px",
              marginBottom: "0px",
            }}
            placeholder={i18n.t("Buscar presupuesto")}
          ></HelveticaInput>
        )}

        <DashboardComponentIconMenu
          setViewMode={setViewMode}
          viewSelected={view}
        />

        {user ? (
          user.freeTrialExpired ||
          user["custom:role"] === "WORKER" ? null : projects.length > 0 ? (
            <button
              type="button"
              onClick={handleOpenNew}
              className="AddContact"
              data-element="newProjectBtn"
              data-testid="dashboard-new-project-button"
              style={{ height: "40px", width: "200px" }}
            >
              {i18n.t("Nuevo Presupuesto")}
            </button>
          ) : null
        ) : null}
      </div>

      {!showBlockingProjectsLoading ? (
        projects.length > 0 ? (
          uploadDB === false ? (
            <>
              <div style={{ width: "100%", height: 16 }}>
                {loadingProjects ? (
                  <LinearProgress sx={{ width: "100%", height: 4 }} />
                ) : null}
              </div>
              <Row style={{ gap: "2rem" }}>
                <CardProject
                  projects={projects}
                  onClickPersonalModal={setModal_standard}
                  vista={view}
                  contactos={Contacts}
                  setUploadDB={setUploadDB}
                  deleteProject={deleteProject}
                  palabrasFiltered={palabrasFiltered}
                  setmodal_first={setModal_first}
                  dashboardConfigFilters={dashboardConfigFilters}
                />
              </Row>
            </>
          ) : (
            navigate("/dashboard/DB")
          )
        ) : uploadDB === false ? (
          <NoProjects
            setUploadDB={setUploadDB}
            setModal_standard={setModal_standard}
            modal_first={modal_first}
            setModal_first={setModal_first}
          />
        ) : (
          navigate("/dashboard/DB")
        )
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            minHeight: "calc(100dvh - 200px)",
          }}
        >
          <Loading />
        </Box>
      )}

      {modal_standard && (
        <PersonalModal
          modal_standard={modal_standard}
          setmodal_standard={setModal_standard}
          setModalUpload={setModal_upload}
          contactos={Contacts}
          setSeleccionado={setSeleccionado}
          modal_first={modal_first}
          setmodal_first={setModal_first}
        />
      )}

      {modal_first && (
        <ModalFirstProject
          modal_first={modal_first}
          setmodal_first={setModal_first}
          setModalUpload={setModal_upload}
          contactos={Contacts}
          setSeleccionado={setSeleccionado}
          setFirstProject={setFirstProject}
        />
      )}

      {modal_upload && (
        <UploadModal
          openModal={modal_upload}
          setOpenModal={setModal_upload}
          setWaitModal={setWaitModal}
          proyecto={projectSeleccionado}
          setSuccessModal={setSuccessModal}
        />
      )}

      {waitModal ? (
        <WaitingModal
          openModal={waitModal}
          setOpenModal={setWaitModal}
          setSuccessModal={setSuccessModal}
          setSeleccionado={setSeleccionado}
          project={projectSeleccionado}
          deleteProject={deleteProject}
          setUploadModal={setModal_upload}
        />
      ) : null}
      {successModal && (
        <SuccessModal
          setSuccessModal={setSuccessModal}
          successModal={successModal}
          project={projectSeleccionado}
        />
      )}
      {mobileModal && (
        <MobileModalNew open={mobileModal} setOpen={setMobileModal} />
      )}

      <ModalSelectTypeProject
        modalNew={modalNew}
        setModalNew={setModalNew}
        setmodal_first={setModal_first}
        onClickPersonalModal={onClickPersonalModal}
      />
      {loadingPendingActions && (
        <ModalWaitingPendingActions
          open={openModalPendingActions}
          setOpen={setOpenModalPendingActions}
        />
      )}

      {openError && (
        <ModalCallError
          open={openError}
          setOpen={setOpenError}
          error={errorToSend}
          ubicacion={"Modal pending Actions"}
        />
      )}
      {openSelectFirstPage && (
        <ModalFirstPage
          open={openSelectFirstPage}
          setOpen={setOpenSelectFirstPage}
        />
      )}
    </>
  )
}

export default DashboardComponent
